export default "__VITE_ASSET__103536cc__"